var app = angular.module("leonardo");

var WorkOrderActions = function ($scope, $state, $rootScope, PermissionService, ReportService, FilterService, AnalyticsService, StatsigService, WorkOrderProviderService, AuthDataService) {

  $scope.permissionService = PermissionService;

  $scope.goToWorkOrderReport = function () {
    ReportService.setQuickReport({filters: FilterService.filters});
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $state.go('reports.work-orders');
  };

  $scope.showCreateWorkOrder = async function() {
    var didActivateGate = false;
    function cleanupGate() {
      if (didActivateGate) {
        StatsigService.deactivateContextualGate('work_orders_new_experience');
        didActivateGate = false;
      }
    }
    try {
      var inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        inIframe = true;
      }

      const useNewExperience = inIframe ? true : await StatsigService.checkGate('work_orders_new_experience');

      if (!inIframe && useNewExperience) {
        StatsigService.activateContextualGate('work_orders_new_experience');
        didActivateGate = true;
      }
      
      WorkOrderProviderService.openWorkOrder({
        useExpoIntegration: useNewExperience,
        action: 'create',
        data: {
          property: FilterService.currentProperty,
          account: FilterService.currentProperty ? FilterService.currentProperty.account : null
        },
        closeCallback: function(result) {
          cleanupGate();
          if (result) {
            // Broadcast event to refresh the work order list
            $rootScope.$broadcast('work-order:created');
          }
        }
      }).catch(function(error) {
        console.error('[WORK_ORDER_ACTIONS] Failed to open dialog:', error);
        cleanupGate();
      });
    } catch (error) {
      console.error('[WORK_ORDER_ACTIONS] Failed to open work order:', error);
      cleanupGate();
    }
  };

};

app.controller('WorkOrderActions', ['$scope', '$state', '$rootScope', 'PermissionService', 'ReportService',
  'FilterService', 'AnalyticsService', 'StatsigService', 'WorkOrderProviderService', 'AuthDataService', WorkOrderActions]);